import React from 'react'

const PrivacyHeader = () => {
  return (
    <header id="header" className="ex-header">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <h1 className="white">Privacy Policy</h1>
      </div> {/* end of col */}
    </div> {/* end of row */}
  </div> {/* end of container */}
</header>

  )
}

export default PrivacyHeader